/**
 * Polyfills for the Screen Management API
 */
export interface ScreenDetailed extends Screen {
    availLeft: number;
    availTop: number;
    devicePixelRatio: number;
    isExtended: boolean;
    isInternal: boolean;
    isPrimary: boolean;
    label: string;
    left: number;
    onchange: unknown;
    top: number;
}

export interface ScreenDetails {
    currentScreen: ScreenDetailed;
    screens: ScreenDetailed[];
}

export function isWindowManagementSupported() {
    return 'getScreenDetails' in window;
}

export async function getScreenDetails(): Promise<ScreenDetails> {
    return (window as any).getScreenDetails();
}

export async function requestWindowManagementPermission(): Promise<PermissionState> {
    try {
        return (await navigator.permissions.query({ name: 'window-management' as any })).state;
    } catch (err) {
        if (err instanceof Error && err.name !== 'TypeError') {
            this.logger.error(err.message);
            return 'denied';
        }
        try {
            return (await navigator.permissions.query({ name: 'window-placement' as any })).state;
        } catch (err) {
            this.logger.error(err.message);
            return 'denied';
        }
    }
}
